import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { Organization } from "../organization";
import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { type Population } from "./entity";

export const PopulationEntityConfig: HyperEntityConfig<Population> = {
  allowApiRead: true,
  allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager],
  apiPrefilterPerRole: async (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, false);

    filter([Roles.Admin, Roles.SuperAdmin, Roles.Manager], {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.User, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmins, {
      organization: {
        $id: remult.user?.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperAdmins, {
      organization: {
        $id: remult.user?.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },
};

